import { render, staticRenderFns } from "./LicenciaOficialColectivaComponent.vue?vue&type=template&id=ee6c3054"
import script from "./LicenciaOficialColectivaComponent.vue?vue&type=script&lang=js"
export * from "./LicenciaOficialColectivaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports